import React from 'react';

const Copyright = React.memo(function Copyright() {
    return (
        <div
            className="d-flex justify-content-center align-items-end text-muted w-100 pb-l5-48"
            data-testid="copyright"
        >
            {`© ${new Date().getFullYear()} Lumen5`}
        </div>
    );
});

export default Copyright;
